import NativeSelect from '@mui/material/NativeSelect';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Field } from 'redux-form';
import { reloadTable } from '../../../../actions/AsyncTable';
import { changeStudentStatus } from '../../../../actions/getUsers';
import { openRequestModal } from '../../../../actions/modals';
import { getPaymentsHistory } from '../../../../actions/payments';
import { getErrorNotification } from '../../../../actions/toast';
import {
    ACTIVE_GROUP_CANDIDATE_STATUSES,
    RESTRICTED_STATUSES_SCHEMA,
    STATUS_MAP,
    USER_STATUSES,
    USER_STATUSES_TEACHER,
} from '../../../../constants/statuses';
import store from './../../../../store';

const withCurrentPromo = (list, status) =>
    Number(status) === 8 ? [{ id: 8, title: STATUS_MAP[8], disabled: true }, ...list] : list;

const isGroupPage = pathname => /^\/groups\/[^/]+\/?$/.test(pathname || '');

const isPromoGroup = (row, courseType, pathname, groupLoaded) =>
    Number(row?.course_type) === 2 || (isGroupPage(pathname) && (!groupLoaded || Number(courseType) === 2));

const processStatuses = (status, roleId, row, courseType, pathname, groupLoaded) => {
    const { role_id: rowRoleId } = row || {};
    if (rowRoleId === 4) {
        return USER_STATUSES_TEACHER;
    }
    if (isPromoGroup(row, courseType, pathname, groupLoaded)) {
        const current = Number(status);
        return [{ id: current, title: STATUS_MAP[current], disabled: true }];
    }

    let base;
    if (roleId <= 2) {
        base = USER_STATUSES;
    } else {
        const allowedCourseTypes = [0, 3, 5];
        if (Number(status) === 6 && (allowedCourseTypes.includes(Number(courseType)) || allowedCourseTypes.includes(Number(row.course_type)))) {
            base = ACTIVE_GROUP_CANDIDATE_STATUSES;
        } else {
            base = RESTRICTED_STATUSES_SCHEMA[status];
        }
    }
    const withoutPromo = base.filter(item => Number(item.id) !== 8);

    return withCurrentPromo(withoutPromo, status);
};

const renderTextField = React.memo(({ input, i18n, roleId, courseType, pathname, groupLoaded, ...custom }) => {
    const value = Number(input.value);
    const array = processStatuses(value, roleId, custom.row, courseType, pathname, groupLoaded);
    return (
        <NativeSelect
            {...input}
            {...custom}
            disabled={custom.row?.role_id !== 4 && isPromoGroup(custom.row, courseType, pathname, groupLoaded)}
            style={{ width: '100px' }}
        >
            {array.map(item => (
                <option
                    key={item.id}
                    value={item.id}
                    disabled={(value === 2 || value === 3) && item.id === 6 ? false : item.disabled}
                >
                    {i18n.t('users.' + item.title)}
                </option>
            ))}
        </NativeSelect>
    );
});

const handleChangeStatus = (code, id, event) => {
    changeStudentStatus(JSON.stringify({ code, id }), event.target.value)(store.dispatch, store.getState);
};

export default React.memo(({ code, id, type, roleId, data }) => {
    const { i18n } = useTranslation();
    const { pathname } = useLocation();
    const courseType = useSelector(state => state?.groups?.single?.course_type);
    const groupLoaded = useSelector(state => Boolean(state?.groups?.single));
    return (
        <Field
            name={JSON.stringify({ code, id })}
            onChange={async event => {
                const { role_id, status, balance } = data;
                const numberValue = Number(event.target.value);
                if (role_id === 5 && numberValue === 4) {
                    const payments = await getPaymentsHistory(false, {
                        user_id: id,
                        size: 9999,
                    })(store.dispatch, store.getState);
                    const isChargeReg = payments.findIndex(el => el.tran_type === 'charge_reg');
                    if (isChargeReg === -1) {
                        getErrorNotification(i18n.t('error.ChargeRegIsNotPresented'));
                        reloadTable()(store.dispatch, store.getState);
                        return;
                    }
                }
                if (role_id === 5 && status === 1 && balance < 0 && numberValue === 0) {
                    event.preventDefault();
                    const { first_name, last_name } = data;
                    openRequestModal({
                        opened: true,
                        data: {
                            id,
                            header: `${i18n.t('payments.student_activation')} | ${first_name} ${last_name}`,
                            user: data,
                            modaltype: 'ConfirmUnblockModal',
                        },
                    })(store.dispatch, store.getState);
                    return;
                }
                handleChangeStatus(code, id, event);
            }}
            i18n={i18n}
            component={renderTextField}
            courseType={courseType}
            pathname={pathname}
            groupLoaded={groupLoaded}
            data={type}
            type="text"
            roleId={roleId}
            row={data}
        />
    );
});
